import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';

import { authState } from '../recoil/authState';
import axios from 'axios';

export default function useAuth() {
    const [isLoading, setIsLoading] = useState(false);
    const [isInvalidUser, setIsInvalidUser] = useState(false);

    const [auth, setAuth] = useRecoilState(authState);

    const { search } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const isDev = process.env.NODE_ENV == 'development';
        const params = new URLSearchParams(search);
        const initialToken = isDev
            ? params.get('token') || process.env.REACT_APP_TEST_TOKEN
            : params.get('token') ?? '';
        const storedToken = localStorage.getItem('auth-token') ?? '';
        const tokenToSend = initialToken ? initialToken : storedToken;
        localStorage.setItem('auth-token', tokenToSend);


        console.log('process.env.REACT_APP_API_URL :', process.env.REACT_APP_API_URL);
        (async () => {
            setIsLoading(true);
            try {
                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/authToken`,
                    {},
                    {
                        headers: {
                            Authorization: (() => {
                                const token =
                                    localStorage.getItem('auth-token');
                                return `Bearer ${token}`;
                            })(),
                        },
                    }
                );

                if (!res?.data?.user) {
                    setIsInvalidUser(true);
                    return;
                }
                // localStorage.setItem("auth-token", tokenToSend);
                // if (res.data?.user?.profile?.dob) {
                //   const age = getAge(new Date(res.data.user?.profile?.dob));
                //   res.data.user.age = age;
                // }

                setAuth({
                    isLoggedIn: true,
                    user: res.data.user,
                    token: tokenToSend,
                });
                // navigate("/");
            } catch (e) {
                setIsInvalidUser(true);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    return { auth, isLoading, isInvalidUser };
}
